






import { computed, defineComponent, useContext } from '@nuxtjs/composition-api';
import { copyToClipboard } from '@/utils/text';
import { useAlerts } from '~/features/alerts';

export default defineComponent({
  name: 'ShareButton',
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { route, $config } = useContext();
    const url = computed(() => {
      return `${$config.appURL}${route.value.path}`;
    });

    const { success } = useAlerts();

    function copyLink() {
      copyToClipboard(url.value);
      success('Linked Copied');
    }

    async function share() {
      // using the native Web Share API
      const shareData = {
        title: props.title,
        text: props.text,
        url: url.value,
      };

      if ('share' in navigator) {
        await navigator.share(shareData);
        return;
      }

      copyLink();
    }

    return {
      url,
      share,
      copyLink,
    };
  },
});
